import {loadable} from 'router/routes';
import {Page} from 'router/page';
import {fetchCity, fetchDestination, foldWithSearchState} from './utils';
import React from 'react';
import EventsAPI from 'api/events';
import isNil from 'lodash/isNil';
import Config from 'config';

const SearchMobile = loadable(() => import('search/SearchMobile'));
const SearchDesktop = loadable(() => import('search/SearchDesktop'));

// eslint-disable-next-line react/prop-types
const Destination = ({configData: {isMobile}}) =>
    isMobile ? <SearchMobile /> : <SearchDesktop />;

Destination.getInitialState = async ({state, params, query, cookies}) => {
    const citySlug = params.city;
    const city = await fetchCity(state, citySlug);
    const destination = await fetchDestination(params, state, citySlug);

    const {
        data: {timezone},
    } = city;

    const {
        data: {
            latitude,
            longitude,
            id: destinationId,
            has_upcoming_events: hasEvents,
        },
    } = destination;

    if (!isNil(query.eid)) {
        const {data: event} = await EventsAPI.getById(query.eid);

        return foldWithSearchState({
            state: {
                ...state,
                city,
                destination,
                event,
            },
            type: Page.EVENT,
            latitude,
            longitude,
            timezone,
            query: {
                ...query,
                starts: event.starts,
                ends: event.ends,
            },
            cookies,
        });
    }

    if (hasEvents && !Config.isMobile) {
        destination.data.events = await EventsAPI.get({destinationId}).then(
            res => res.data.data.results
        );
    }

    return foldWithSearchState({
        state: {
            ...state,
            city,
            destination,
        },
        type: hasEvents ? 'venue' : Page.DESTINATION,
        latitude,
        longitude,
        timezone,
        query,
        cookies,
    });
};

export default Destination;
